<button
  type="button"
  class="dtp-trigger"
  (click)="toggle()"
  [attr.aria-label]="ariaLabel || ('components.dateTimePicker.ariaLabel' | translate)"
  aria-haspopup="dialog"
  [attr.aria-expanded]="open()"
>
  <svg class="dtp-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="5" width="18" height="16" rx="3"/>
    <line x1="16" y1="3" x2="16" y2="7"/>
    <line x1="8" y1="3" x2="8" y2="7"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
  <span class="dtp-trigger-text" [class.dtp-placeholder]="!displayLabel()">
    {{ displayLabel() || placeholder || ('components.dateTimePicker.placeholder' | translate) }}
  </span>
</button>

@if (open()) {
  <div class="dtp-popover" role="dialog" [class.dtp-popover--up]="openUpward()">
    <div class="dtp-cal-header">
      <button type="button" class="dtp-nav-btn" (click)="prevMonth()" [attr.aria-label]="'components.dateTimePicker.prevMonth' | translate">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
      </button>
      <div class="dtp-cal-title">{{ monthLabel() }}</div>
      <button type="button" class="dtp-nav-btn" (click)="nextMonth()" [attr.aria-label]="'components.dateTimePicker.nextMonth' | translate">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
    </div>

    <div class="dtp-weekdays">
      @for (d of weekdayLabels(); track $index) {
        <div class="dtp-weekday">{{ d }}</div>
      }
    </div>

    <div class="dtp-days-grid">
      @for (day of calendarDays(); track day.date.getTime()) {
        <button type="button" class="dtp-day"
          [class.dtp-day--muted]="!day.inMonth"
          [class.dtp-day--today]="day.isToday"
          [class.dtp-day--selected]="day.isSelected"
          [class.dtp-day--disabled]="day.disabled"
          [disabled]="day.disabled"
          (click)="selectDay(day)">
          {{ day.date.getDate() }}
        </button>
      }
    </div>

    <div class="dtp-divider"></div>

    <div class="dtp-time-row">
      <svg class="dtp-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 16 14"/></svg>

      <div class="dtp-stepper">
        <input type="text" inputmode="numeric" maxlength="2" class="dtp-stepper-input"
               [value]="hourStr()" (change)="onHourInput($any($event.target).value)"
               [attr.aria-label]="'components.dateTimePicker.hourLabel' | translate">
        <div class="dtp-stepper-arrows">
          <button type="button" (click)="adjustHour(1)" aria-label="+1">
            <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="18 15 12 9 6 15"/></svg>
          </button>
          <button type="button" (click)="adjustHour(-1)" aria-label="-1">
            <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
        </div>
      </div>

      <span class="dtp-colon">:</span>

      <div class="dtp-stepper">
        <input type="text" inputmode="numeric" maxlength="2" class="dtp-stepper-input"
               [value]="minuteStr()" (change)="onMinuteInput($any($event.target).value)"
               [attr.aria-label]="'components.dateTimePicker.minuteLabel' | translate">
        <div class="dtp-stepper-arrows">
          <button type="button" (click)="adjustMinute(1)" aria-label="+1">
            <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="18 15 12 9 6 15"/></svg>
          </button>
          <button type="button" (click)="adjustMinute(-1)" aria-label="-1">
            <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
        </div>
      </div>
    </div>

    <div class="dtp-actions">
      <button type="button" class="dtp-clear" (click)="clear()">{{ 'components.dateTimePicker.clearButton' | translate }}</button>
      <button type="button" class="dtp-done" (click)="close()">{{ 'components.dateTimePicker.doneButton' | translate }}</button>
    </div>
  </div>
}
